import React, { useState } from 'react';

import { c } from 'ttag';

import { Badge, Button } from '@freelancelabs/components';

import { OrganizationKind } from '../../graphql/__generated__/schema';
import PortalAccessDialog, { PortalAccessDirection } from './PortalAccessDialog';

interface Props {
    accountId: string;
    accountName: string;
    portalEnabled: boolean | null | undefined;
    kind: OrganizationKind | null | undefined;
}

const PortalAccessPanel = ({ accountId, accountName, portalEnabled, kind }: Props) => {
    const [direction, setDirection] = useState<PortalAccessDirection | null>(null);

    // Freelance.com carries no portal access at all; the mutation refuses it, so the button would be a dead control.
    if (kind === OrganizationKind.Internal) {
        return null;
    }

    // Null is not "closed": a missing field must not offer "Open" on an account that may already be open.
    if (portalEnabled === null || portalEnabled === undefined) {
        return null;
    }

    return (
        <div className="flex flex-wrap items-center gap-x-4 gap-y-2 rounded-lg border border-border-norm bg-background-norm px-4 py-3">
            <div className="min-w-0">
                <div className="flex flex-wrap items-center gap-2">
                    <h2 className="text-sm font-semibold text-text-900">{accountName}</h2>
                    <Badge category={portalEnabled ? 'success' : 'default'} size="small">
                        {portalEnabled
                            ? c('Portal access').t`Open to the portal`
                            : c('Portal access').t`Closed to the portal`}
                    </Badge>
                </div>
            </div>

            <Button className="ml-auto" category="weak" onClick={() => setDirection(portalEnabled ? 'close' : 'open')}>
                {portalEnabled
                    ? c('Portal access action').t`Close this account to the portal…`
                    : c('Portal access action').t`Open this account to the portal…`}
            </Button>

            {direction && (
                <PortalAccessDialog
                    accountId={accountId}
                    accountName={accountName}
                    direction={direction}
                    onClose={() => setDirection(null)}
                />
            )}
        </div>
    );
};

export default PortalAccessPanel;
